module.exports = __webpack_public_path__ + "img/child-two.1c8f76e7.png";